import ClockInfoView from '../default/clock_info_view';

const ClockInfoContainer = () => (
  <ClockInfoView isOutright />
);

export default ClockInfoContainer;
